export default __webpack_public_path__ + "assets/time-19da1eb396dc5a5014bb87b0318cdf54.svg";